import React from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../hooks/use_should_show_price_by_offer_config_and_user";
import {OfferPriceType} from "../../offer/types/OfferPriceType";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../property/utils/get_property_badge_type";
import {PromotionButton} from "../../property_list/components/property_list_application_button/PromotionButton";
import {ReservedButton} from "../../property_list/components/property_list_application_button/ReservedButton";
import {gtmEventPropertyButton} from "../../tracking/google_tag_manager/gtm_event_property_button";
import {getPropertyButtonEventMeta} from "../../tracking/google_tag_manager/utils/get_property_button_event_meta";
import {getCurrency} from "../../utils/get_currency";

interface Props {
    property: IPropertyListProperty;
    buttonVariant?: "outlined_secondary" | "highlight_primary";
    isPlansList?: boolean;
    isInModal?: boolean;
    link?: string;
}

export const PropertyViewRedirectButton = (props: Props) => {
    const {property, buttonVariant = "outlined_secondary", isPlansList, isInModal, link} = props;

    const target = useResponsiveLinkTarget();
    const propertyBadgeType = getPropertyBadgeType(property);
    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });
    const price = property.price;
    const showPrice = shouldShowPrice && !!price;
    const priceType = property.price_type ?? property.offer.price_type;
    const priceTypeLabel = priceType === OfferPriceType.NETTO ? " netto" : "";
    const showPriceLabel = !isPlansList && showPrice;
    const showPromotionButton = (propertyBadgeType === "promotion" && !isPlansList) || (property.is_promo && !isPlansList);
    const showReservationButton = propertyBadgeType === "reservation" && !isPlansList;
    const handleClick = () => {
        const eventMeta = getPropertyButtonEventMeta({isPromotion: showPromotionButton, isReservation: showReservationButton, isPlansList, isInModal});

        gtmEventPropertyButton({event: eventMeta.event, eventLabel: eventMeta.label});
    };

    if (showPromotionButton) {
        return (
            <div className={buttonWrapper}>
                {link && <a href={link} target={target} className={linkStyle} onClick={handleClick} />}
                <PromotionButton onClick={link ? undefined : handleClick} property={property} showPrice={showPrice} />
            </div>
        );
    }

    if (showReservationButton) {
        return (
            <div className={buttonWrapper}>
                {link && <a href={link} target={target} className={linkStyle} onClick={handleClick} />}
                <ReservedButton onClick={link ? undefined : handleClick} />
            </div>
        );
    }

    return (
        <div className={buttonWrapper}>
            {showPriceLabel && (
                <Text variant="body_copy_2" as="span" strong>
                    {priceFormat(price, {unit: `${getCurrency({currency: property.offer.currency})}${priceTypeLabel}`})}
                </Text>
            )}

            <Button
                variant={buttonVariant}
                href={link}
                target={link ? target : undefined}
                size="x-small"
                onClick={handleClick}
                className={cx(isPlansList && css({w: "100%"}))}
            >
                <Text variant={isPlansList ? "button_small" : "button_micro"} align="center">
                    Zobacz więcej
                </Text>
            </Button>
        </div>
    );
};

const buttonWrapper = css({
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});

const linkStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});
import React from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useShouldShowPriceByOfferConfigAndUser} from "../../hooks/use_should_show_price_by_offer_config_and_user";
import {OfferPriceType} from "../../offer/types/OfferPriceType";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getPropertyBadgeType} from "../../property/utils/get_property_badge_type";
import {PromotionButton} from "../../property_list/components/property_list_application_button/PromotionButton";
import {ReservedButton} from "../../property_list/components/property_list_application_button/ReservedButton";
import {gtmEventPropertyButton} from "../../tracking/google_tag_manager/gtm_event_property_button";
import {getPropertyButtonEventMeta} from "../../tracking/google_tag_manager/utils/get_property_button_event_meta";
import {getCurrency} from "../../utils/get_currency";

interface Props {
    property: IPropertyListProperty;
    buttonVariant?: "outlined_secondary" | "highlight_primary";
    isPlansList?: boolean;
    isInModal?: boolean;
    link?: string;
}

export const PropertyViewRedirectButton = (props: Props) => {
    const {property, buttonVariant = "outlined_secondary", isPlansList, isInModal, link} = props;

    const target = useResponsiveLinkTarget();
    const propertyBadgeType = getPropertyBadgeType(property);
    const shouldShowPrice = useShouldShowPriceByOfferConfigAndUser({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });
    const price = property.price;
    const showPrice = shouldShowPrice && !!price;
    const priceType = property.price_type ?? property.offer.price_type;
    const priceTypeLabel = priceType === OfferPriceType.NETTO ? " netto" : "";
    const showPriceLabel = !isPlansList && showPrice;
    const showPromotionButton = (propertyBadgeType === "promotion" && !isPlansList) || (property.is_promo && !isPlansList);
    const showReservationButton = propertyBadgeType === "reservation" && !isPlansList;
    const handleClick = () => {
        const eventMeta = getPropertyButtonEventMeta({isPromotion: showPromotionButton, isReservation: showReservationButton, isPlansList, isInModal});

        gtmEventPropertyButton({event: eventMeta.event, eventLabel: eventMeta.label});
    };

    if (showPromotionButton) {
        return (
            <div className={buttonWrapper}>
                {link && <a href={link} target={target} className={linkStyle} onClick={handleClick} />}
                <PromotionButton onClick={link ? undefined : handleClick} property={property} showPrice={showPrice} />
            </div>
        );
    }

    if (showReservationButton) {
        return (
            <div className={buttonWrapper}>
                {link && <a href={link} target={target} className={linkStyle} onClick={handleClick} />}
                <ReservedButton onClick={link ? undefined : handleClick} />
            </div>
        );
    }

    return (
        <div className={buttonWrapper}>
            {showPriceLabel && (
                <Text variant="body_copy_2" as="span" strong>
                    {priceFormat(price, {unit: `${getCurrency({currency: property.offer.currency})}${priceTypeLabel}`})}
                </Text>
            )}

            <Button
                variant={buttonVariant}
                href={link}
                target={link ? target : undefined}
                size="x-small"
                onClick={handleClick}
                className={cx(isPlansList && css({w: "100%"}))}
            >
                <Text variant={isPlansList ? "button_small" : "button_micro"} align="center">
                    Zobacz więcej
                </Text>
            </Button>
        </div>
    );
};

const buttonWrapper = css({
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});

const linkStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});
